import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    // Fehler in Konsole loggen für Debugging
    console.error('React ErrorBoundary gefangen:', error, errorInfo);

    // Prüfen auf Hook-Fehler
    if (error.message && error.message.includes('Invalid hook call')) {
      console.error('Hook-Fehler erkannt. Mögliche Ursachen:');
      console.error('1. Mehrere React-Versionen könnten geladen sein');
      console.error('2. Ein Hook wird außerhalb einer Funktionskomponente aufgerufen');
      console.error('3. Die Regeln der Hooks werden nicht eingehalten');
    }
  }

  render() {
    if (this.state.hasError) {
      // Benutzerfreundliche Fehleranzeige
      return (
        <div className="error-boundary p-4 bg-red-50 border border-red-200 rounded shadow">
          <h2 className="text-red-600">Etwas ist schief gelaufen.</h2>
          <details className="mt-2">
            <summary className="text-sm text-gray-600 cursor-pointer">Technische Details anzeigen</summary>
            <pre className="mt-2 p-2 bg-red-100 rounded text-xs overflow-auto">
              {this.state.error && this.state.error.toString()}
            </pre>
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
